import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMicrophoneRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M8 2.8q1.1 0 1.2 1.2v3.2a1.2 1.2 0 0 1-2.4 0V4q0-1.1 1.2-1.2M5.6 4v3.2a2.4 2.4 0 0 0 4.8 0V4a2.4 2.4 0 0 0-4.8 0M4.4 6.2a.6.6 0 1 0-1.2 0v1c0 2.4 1.8 4.5 4.2 4.8v1.2H6.2a.6.6 0 1 0 0 1.2h3.6a.6.6 0 1 0 0-1.2H8.6V12a5 5 0 0 0 4.2-4.8v-1a.6.6 0 1 0-1.2 0v1a3.6 3.6 0 0 1-7.2 0z" })
});
export default SvgMicrophoneRegularIcon;
